import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import starIcon from '../../assets/images/star-icon.png'

const OurSolutions = () => {
  const { solutions, services } = useStaticQuery(
    graphql`
      query {
        solutions: allContentfulHomeItServices {
          edges {
            node {
              solutionSub
              solutionTitle
              solutionContent {
                solutionContent
              }
            }
          }
        }
        services: allContentfulServices(
          limit: 3
          sort: { order: DESC, fields: createdAt }
        ) {
          edges {
            node {
              slug
              title
              icon
              excerpt {
                excerpt
              }
            }
          }
        }
      }
    `
  )

  const {
    solutionSub,
    solutionTitle,
    solutionContent,
  } = solutions.edges[0].node

  return (
    <section className="solutions-area pb-70">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={starIcon} alt="star" />
            {solutionSub}
          </span>
          <h2>{solutionTitle}</h2>
          <p>{solutionContent.solutionContent}</p>
        </div>

        {services ? (
          <div className="row">
            {services.edges.map((service, index) => {
              const cls =
                index === 2
                  ? 'col-lg-4 col-sm-6 offset-lg-0 offset-sm-3'
                  : 'col-lg-4 col-sm-6'
              return (
                <div key={index} className={cls}>
                  <div className="single-solutions-box">
                    <div className="icon">
                      <i className={service.node.icon}></i>
                    </div>
                    <h3>
                      <Link to={`/service/` + service.node.slug}>
                        {service.node.title}
                      </Link>
                    </h3>
                    <p>{service.node.excerpt.excerpt}</p>

                    <Link
                      to={`/service/` + service.node.slug}
                      className="view-details-btn"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              )
            })}
          </div>
        ) : null}
      </div>
    </section>
  )
}

export default OurSolutions
